import ReportAccordion from "./report-accordion.jsx";

export default ReportAccordion;
